import { render, staticRenderFns } from "./ConsultantDetailPage.vue?vue&type=template&id=dfd3078c&scoped=true&"
import script from "./ConsultantDetailPage.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConsultantDetailPage.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd3078c",
  null
  
)

export default component.exports